$(document).ready(function() {
	var mySwiper = new Swiper ('.swiper-container', {
		loop: true,
		pagination: '.swiper-pagination',
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev',
		paginationClickable: true,
		spaceBetween: 30,
		centeredSlides: true,
		autoplay: 2500,
		autoplayDisableOnInteraction: false,
		preventClicks:false,
		preventClicksPropagation:false
	});

	$('.bio-readmore').readmore({
		speed: 75,
		lessLink: '<a href="javascript:;">Voir moins</a>',
		moreLink: '<a href="javascript:;">Voir plus</a>',
		collapsedHeight:120
	});

	$('.carousel').carousel({
		interval: 2000
	})
});